import {useGetAndSet} from "./useGetAndSet";
import {createSetFixedExpenseDataAction} from "../actions/dataActions";


export const useFixedExpenseData = (params, dataFresh) => {
    return useGetAndSet("fixedexpense", params, createSetFixedExpenseDataAction, dataFresh);
}